import React from 'react';
import { Headline } from '@/components/headline/Headline';
import { Button } from '@/components/button/Button';
import { BaseImage } from '@/components/baseImage/BaseImage';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { useTranslations } from '@/lib/locale-context';
import { IntroStepProps } from './types';

const IntroStep: React.FC<IntroStepProps> = ({
  introHeadline,
  introDescription,
  introDisclaimer,
  introImage,
  introButton,
  sectionId,
  onStart,
}) => {
  const { t } = useTranslations();

  return (
    <div id={sectionId} className="container mx-auto px-4 py-6">
      <div className="grid grid-cols-1 gap-8 rounded-2xl bg-white p-8 shadow-sm lg:grid-cols-2 lg:items-center lg:gap-12 lg:p-12">
        {/* Content */}
        <div className="flex flex-col text-center lg:text-left">
          {introHeadline && (
            <Headline {...introHeadline} className={'text-brand-700'} />
          )}

          {introDescription && (
            <SerializeDescription
              className="mb-6 text-base [&_*]:!text-neutral-600"
              description={introDescription}
            />
          )}

          {onStart && (
            <Button
              variant="primary"
              name={introButton?.title || t('progressiveForm.start')}
              rightIcon={{ name: 'arrow-right', size: '18px' }}
              onClick={onStart}
              className="w-full justify-center lg:w-max"
            />
          )}

          {introDisclaimer && (
            <SerializeDescription
              className="mt-6 [&_*]:text-xs [&_*]:!text-neutral-500 [&_*]:lg:text-sm"
              description={introDisclaimer}
            />
          )}
        </div>

        {/* Image */}
        {introImage && (
          <div className="order-first overflow-hidden rounded-2xl lg:order-last">
            <BaseImage
              classNameImage="rounded-2xl aspect-square w-full object-cover"
              {...introImage}
              sizes="(max-width: 1024px) 100vw, 50vw"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default IntroStep;
